import { call, takeLatest, put } from "redux-saga/effects";
import * as profileApi from "../apis/profileApi";
import { PROFILE_VIEW } from "../actions/types";
import { USER_DATA_LOADED } from "../actions/returnType";

export function* profileViewWorker(action) {
    try {
        const res = yield call(profileApi.proflieViewApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data });
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/* Watcher Function*/

export function* profileViewWatcher() {
    yield takeLatest(PROFILE_VIEW, profileViewWorker);
}
